export { default as default } from './AfegirBlocComponent.jsx';